<template>
    <div class="register-container">
        <div class="register-box">
            <div class="register-header">
                <h2>注册</h2>
                <p>小鱼智能控制平台</p>
            </div>

            <el-form
                    ref="registerForm"
                    :model="registerForm"
                    :rules="registerRules"
                    class="register-form"
                    label-width="80px"
            >
                <el-form-item label="用户名" prop="username">
                    <el-input
                            autocomplete="username"
                            v-model="registerForm.username"
                            placeholder="请输入用户名"
                            prefix-icon="el-icon-user"
                    />
                </el-form-item>

                <el-form-item label="邮箱" prop="email">
                    <el-input
                            type="email"
                            autocomplete="email"
                            v-model="registerForm.email"
                            placeholder="请输入邮箱"
                            prefix-icon="el-icon-message"
                    />
                </el-form-item>

                <el-form-item label="密码" prop="password">
                    <el-input
                            v-model="registerForm.password"
                            type="password"
                            placeholder="请输入密码"
                            prefix-icon="el-icon-lock"
                            show-password
                    />
                </el-form-item>

                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input
                            v-model="registerForm.confirmPassword"
                            type="password"
                            placeholder="请确认密码"
                            prefix-icon="el-icon-lock"
                            show-password
                    />
                </el-form-item>

                <el-form-item>
                    <el-button
                            type="primary"
                            :loading="loading"
                            class="register-btn"
                            @click="handleRegister"
                    >
                        注册
                    </el-button>
                </el-form-item>

                <div class="login-link">
                    已有账号？
                    <router-link to="/login">立即登录</router-link>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>

export default {
    name: 'UserRegister',
    data() {
        // 密码确认验证
        const validateConfirmPassword = (rule, value, callback) => {
            if (value !== this.registerForm.password) {
                callback(new Error('两次输入的密码不一致'))
            } else {
                callback()
            }
        }

        return {
            loading: false,
            registerForm: {
                username: '',
                email: '',
                password: '',
                confirmPassword: '',
            },
            registerRules: {
                username: [
                    {required: true, message: '请输入用户名', trigger: 'blur'},
                    {min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur'}
                ],
                email: [
                    {required: true, message: '请输入邮箱', trigger: 'blur'},
                    {type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur'}
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 6, message: '密码长度不能少于 6 个字符', trigger: 'blur'}
                ],
                confirmPassword: [
                    {required: true, message: '请确认密码', trigger: 'blur'},
                    {validator: validateConfirmPassword, trigger: 'blur'}
                ],
            }
        }
    },
    methods: {
        handleRegister() {
            this.loading = true;

            if (this.registerForm.password !== this.registerForm.confirmPassword) {
                this.$message.error('两次输入的密码不一致')
                this.loading = false;
                return
            }

            this.$store.dispatch("Register", this.registerForm).then(() => {
                this.$message.success('注册成功，请重新登录')
                this.$router.push('/login')
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>

<style scoped>
.register-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #eac066 0%, #f87ade 100%);
}

.register-box {
    width: 400px;
    padding: 40px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.register-header {
    text-align: center;
    margin-bottom: 30px;
}

.register-header h2 {
    color: #333;
    margin-bottom: 10px;
    font-size: 28px;
}

.register-header p {
    color: #666;
    font-size: 14px;
}

.register-form {
    margin-top: 20px;
}

.register-btn {
    width: 100%;
    height: 45px;
    font-size: 16px;
    border-radius: 5px;
}

.login-link {
    text-align: center;
    margin-top: 20px;
    color: #666;
    font-size: 14px;
}

.login-link a {
    color: #409eff;
    text-decoration: none;
}

.login-link a:hover {
    text-decoration: underline;
}

@media (max-width: 480px) {
    .register-box {
        width: 90%;
        padding: 30px 20px;
    }
}
</style> 